<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="760px" @close="handleClose" append-to-body>
    <div class="comrel-search">
      <el-input v-model.trim="keyword" placeholder="输入单位名称搜索" clearable style="width:260px"
                @keyup.enter.native="search" @clear="search"></el-input>
      <el-button type="primary" @click="search" style="margin-left:8px">查询</el-button>
    </div>
    <el-table :data="list" border height="420" v-loading="loading">
      <el-table-column type="index" label="行号" width="60"></el-table-column>
      <el-table-column prop="comfullname" label="采购单位" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isrel ? 'success' : 'info'">{{ scope.row.isrel ? '已关联' : '未关联' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button v-if="!scope.row.isrel" type="primary" size="mini" @click="addRel(scope.row)">关联</el-button>
          <el-button v-else type="danger" size="mini" @click="cancelRel(scope.row)">取消关联</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:10px;text-align:right"
      @current-change="pagechange"
      :current-page="page"
      :page-size="limit"
      :total="total"
      layout="total, prev, pager, next">
    </el-pagination>
  </el-dialog>
</template>

<script>
import { getComListByUser, addRel, cancelRel } from '@/api/usercomrel'

export default {
  name: 'userComRelDialog',
  props: {
    visible: { type: Boolean, default: false },
    userId: { type: [Number, String], default: 0 },
    cosid: { type: [Number, String], default: 0 }
  },
  data () {
    return {
      dialogVisible: false,
      title: '关联采购单位',
      keyword: '',
      list: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: false
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
      if (val) {
        this.page = 1
        this.keyword = ''
        this.loadData()
      }
    }
  },
  methods: {
    handleClose () {
      this.$emit('update:visible', false)
    },
    async loadData () {
      if (!this.userId) return
      this.loading = true
      try {
        let res = await getComListByUser({
          userid: this.userId,
          cosid: this.cosid,
          keyword: this.keyword,
          limit: this.limit,
          offset: (this.page - 1) * this.limit
        })
        this.list = res.list || []
        this.total = res.total || 0
      } finally {
        this.loading = false
      }
    },
    search () {
      this.page = 1
      this.loadData()
    },
    pagechange (p) {
      this.page = p
      this.loadData()
    },
    async addRel (row) {
      try {
        await this.$confirm(`确定将用户关联到采购单位「${row.comfullname}」?`, '关联确认', { type: 'warning' })
      } catch (e) {
        return
      }
      let data = await addRel({
        userid: this.userId,
        dcrcomid: row.comid,
        dcruserid: this.$store.getters.loginUser.userid
      })
      if (data.issuccess === 1) {
        this.$message.success(data.msg)
        this.loadData()
      } else {
        this.$message.warning(data.msg)
      }
    },
    async cancelRel (row) {
      this.$confirm('确定取消该采购单位的关联?', '提示', { type: 'warning' }).then(async () => {
        let data = await cancelRel({ dcrid: row.dcrid })
        if (data.issuccess === 1) {
          this.$message.success(data.msg)
          this.loadData()
        } else {
          this.$message.warning(data.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
.comrel-search {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
</style>
